/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Description_TelegramInputs */

const he_account_delivery_unlink_description_telegram = /** @type {(inputs: Account_Delivery_Unlink_Description_TelegramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא תקבל יותר התראות דרך טלגרם. תוכל לקשר מחדש בכל עת.`)
};

const en_account_delivery_unlink_description_telegram = /** @type {(inputs: Account_Delivery_Unlink_Description_TelegramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will no longer receive notifications via Telegram. You can re-link at any time.`)
};

/**
* | output |
* | --- |
* | "You will no longer receive notifications via Telegram. You can re-link at any time." |
*
* @param {Account_Delivery_Unlink_Description_TelegramInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_description_telegram = /** @type {((inputs?: Account_Delivery_Unlink_Description_TelegramInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Description_TelegramInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_description_telegram(inputs)
	return en_account_delivery_unlink_description_telegram(inputs)
});